import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  label: string;
}

export const CustomTimeHeader = ({ label }: Props) => {
  return (
    <Text css={styles.timePeriod} size='medium' weight='bold'>
      <Icon name='clock-small' />
      {label}
    </Text>
  );
};

const styles = {
  timePeriod: css`
    color: ${theme.colors.neutral70};
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
};
